export default __webpack_public_path__ + "images/9f7e312a999df2ca6ce4f9c2a61787cd-adoption-cat-667.png";